import { MachineReportStatus } from '@/generated/codegen';

export const statusOptions: Record<MachineReportStatus, string> = {
  pending: 'Pendiente',
  available: 'Sin Actividad',
  worked: 'Activo',
  out_of_service: 'Fuera de Servicio',
  unknown: 'Desconocido',
};

export const statusOptionsShort: Record<MachineReportStatus, string> = {
  pending: 'PD',
  available: 'SA',
  worked: 'AC',
  out_of_service: 'FS',
  unknown: 'Desconocido',
};
